import { createSlice } from "@reduxjs/toolkit";
import { app_reset } from "../App/reducer";
import { transformLiveStoryGQLResponseToLiveStoryProps } from "../../utils/dataTransform/LiveStory/library";
import { safeDecodeHtmlEntities } from "../../utils/parser/library";

const EMPTY_LIVE_STORY_STATE = {
    content: null,
    updates: [],
    mainMedia: null,
    carouselMedia: [],
    theLatest: [],
    isLoaded: false,
    sharedUpdate: null,
};

const theLatestBodyParser = (bodyParsed) => {
    const nodes = bodyParsed?.[0]?.content;
    return Array.isArray(nodes)
        ? nodes.reduce((theLatest, node) => {
              const text = safeDecodeHtmlEntities(node?.content?.[0]?.content);
              if (text) theLatest.push(text);
              return theLatest;
          }, [])
        : [];
};

export const createLiveStoryPayload = (json) => {
    if (!json?.sourceId) return EMPTY_LIVE_STORY_STATE;

    const { liveStory, ...mainContent } = json;

    const { body, ...content } = mainContent;
    const theLatest = theLatestBodyParser(body?.parsed);

    const safeContent = {
        ...content,
        deck: safeDecodeHtmlEntities(content.deck),
        eventTitle: safeDecodeHtmlEntities(liveStory?.eventTitle),
        title: safeDecodeHtmlEntities(content.title),
    };

    const sharedUpdateRawData = liveStory?.sharedUpdate?.nodes ?? [];
    const sharedUpdate = sharedUpdateRawData.length
        ? transformLiveStoryGQLResponseToLiveStoryProps(sharedUpdateRawData[0])
        : null;

    const liveStoryUpdates = liveStory?.updates?.nodes ?? [];
    const updates = liveStoryUpdates.map(
        transformLiveStoryGQLResponseToLiveStoryProps
    );

    const [mainMedia = null, ...carouselMedia] = body?.associatedContent ?? [];

    return {
        content: safeContent,
        mainMedia,
        carouselMedia,
        theLatest,
        sharedUpdate,
        updates,
        isLoaded: true,
    };
};

const liveStorySlice = createSlice({
    name: "liveStory",
    initialState: EMPTY_LIVE_STORY_STATE,
    reducers: {
        reset_live_story: () => EMPTY_LIVE_STORY_STATE,

        receive_live_story_content: {
            reducer: (state, action) => {
                return {
                    ...state,
                    ...action.payload,
                };
            },
            prepare: (json) => {
                return {
                    payload: {
                        ...createLiveStoryPayload(json),
                    },
                };
            },
        },
    },

    extraReducers: (builder) => {
        builder.addCase(app_reset, () => EMPTY_LIVE_STORY_STATE);
    },
});

export const { reset_live_story, receive_live_story_content } =
    liveStorySlice.actions;

export default liveStorySlice.reducer;
